<div class="row page-header d-flex justify-content-center mx-sm-1">
  <div class="col-12 col-lg-11 col-xl-10">
    <div class="d-flex justify-content-between mb-2 align-items-end px-sm-0">
      <h2 class="page-title" i18n="Tenants label">
        {{ "tenants" | transloco }}
      </h2>
      <div style="display: flex; gap: 5px">
        <p-button
          *ngIf="showDailyEmailsButton"
          class="d-none d-sm-block"
          label="{{ 'Send daily mails' | transloco }}"
          icon="pi pi-send"
          (click)="sendDailyMails()"
        />
        <p-button
          class="d-none d-sm-block"
          label="{{ 'add' | transloco }}"
          icon="pi pi-plus"
          [routerLink]="['/tenants/new']"
        />
      </div>
    </div>
    <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
    <app-tenant-list
      *ngIf="!(repo.isLoading$ | async)"
      style="width: 100%"
      [innerWidth]="innerWidth"
      [tenants]="allTenants"
      [isDeleteDisabled]="
        !(auth.isSuperAdmin$ | async) && !(auth.isPartnerManager$ | async)
      "
      (delete)="delete($event)"
      (clone)="handleCloneClick($event); (refreshData)"
    ></app-tenant-list>
  </div>
</div>

<p-button
  class="d-block d-sm-none mobile-add-button"
  icon="pi pi-plus"
  [routerLink]="['new']"
/>
